
import { useTranslation } from "react-i18next"
import { format } from "date-fns"
import { Calendar } from "lucide-react"

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"

// Mock data for user appointments
const userAppointments = [
  {
    id: "1",
    title: "Personal Training Session",
    date: new Date(2023, 4, 15, 10, 0),
    endDate: new Date(2023, 4, 15, 11, 0),
    trainerName: "Mike Johnson",
    status: "confirmed",
    notes: "Focus on upper body strength",
  },
  {
    id: "2",
    title: "Yoga Session",
    date: new Date(2023, 4, 16, 14, 0),
    endDate: new Date(2023, 4, 16, 15, 0),
    trainerName: "Jane Smith",
    status: "confirmed",
    notes: "Beginner level session",
  },
  {
    id: "3",
    title: "CrossFit Training",
    date: new Date(2023, 4, 17, 9, 0),
    endDate: new Date(2023, 4, 17, 10, 30),
    trainerName: "David Brown",
    status: "pending",
    notes: "High intensity workout",
  },
]

export function UserAppointments() {
  const { t } = useTranslation()

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Calendar className="mr-2 h-5 w-5" />
          {t("userView.upcomingAppointments")}
        </CardTitle>
        <CardDescription>{t("userView.appointmentsDescription")}</CardDescription>
      </CardHeader>
      <CardContent>
        {userAppointments.length > 0 ? (
          <div className="space-y-4">
            {userAppointments.map((appointment) => (
              <div key={appointment.id} className="flex flex-col space-y-2 p-3 border rounded-md">
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="font-medium">{appointment.title}</h3>
                    <p className="text-sm text-muted-foreground">
                      {format(appointment.date, "EEEE, MMMM d")} • {format(appointment.date, "HH:mm")} -{" "}
                      {format(appointment.endDate, "HH:mm")}
                    </p>
                  </div>
                  <Badge
                    variant={appointment.status === "confirmed" ? "default" : "secondary"}
                    className={appointment.status === "confirmed" ? "bg-green-500" : "bg-yellow-500"}
                  >
                    {appointment.status === "confirmed" ? t("appointments.confirmed") : t("appointments.pending")}
                  </Badge>
                </div>
                <div>
                  <p className="text-sm">
                    <span className="font-medium">{t("appointments.trainer")}:</span> {appointment.trainerName}
                  </p>
                  {appointment.notes && (
                    <p className="text-sm mt-1">
                      <span className="font-medium">{t("appointments.notes")}:</span> {appointment.notes}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4 text-muted-foreground">{t("userView.noAppointments")}</div>
        )}
      </CardContent>
    </Card>
  )
}
